import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type WorkflowContextResourceV3 = OpalApiComponent<'V3', 'workflow_context'>

export const workflowContextResourceFactory: Factory<WorkflowContextResourceV3> =
  Factory.define<WorkflowContextResourceV3>(() => {
    const now = new Date().toISOString()
    return {
      id: uuidV4(),
      type: 'workflow_context',
      attributes: { created_at: now, updated_at: now },
      relationships: {
        block: { data: { id: uuidV4(), type: 'block' } },
        created_by_user: { data: { id: uuidV4(), type: 'user' } },
        moment: { data: null },
        workflow: { data: { id: uuidV4(), type: 'workflow' } },
      },
    } satisfies WorkflowContextResourceV3
  })
